import ColorPicker from 'pages/Whiteboard/controlPanel/ColorPicker';

import DropDown from '../MenuItemDropdown';
import style from '../SelectedItemMenu.module.css';

interface Props {
  fill: string;
  onChange: (val) => void;
}
const FillColorPicker = (props: Props) => {
  return (
    <DropDown
      trigger={
        <div
          className={style.colorSelector}
          style={{ borderColor: props.fill, background: props.fill }}
        ></div>
      }
      closeOnClick={true}
    >
      <ColorPicker
        theme="dark"
        value="black"
        onChange={val => {
          props.onChange({ changed: 'fill', value: val });
        }}
      />
    </DropDown>
  );
};

export default FillColorPicker;
